<template>
  <section class="timeline-carousel__wrapper global__fade-in-up dont-print">
    <div class="background__image">
      <!-- Handles background transition -->
      <transition tag="div" name="fade" mode="out-in">
        <img
          :key="getCardData[currentIndex].year"
          :src="getCardData[currentIndex].background.src"
          alt=""
        />
      </transition>
    </div>

    <slot />
    <!-- includes the background shade -->

    <div class="timeline-carousel__row global__fade-in-up">
      <div class="timeline-carousel__left base-lockup--light">
        <h2 class="base-lockup__heading base-lockup__heading--2">
          {{ header }}
        </h2>

        <div class="button-skip-content__wrap">
          <a href="#end-timeline-carousel" class="button-skip-content">
            Skip timeline content
          </a>
        </div>
      </div>

      <!-- Carousel proper starts here -->
      <div class="timeline-carousel__right">
        <div class="timeline-carousel__controls timeline-carousel__prev">
          <button
            :class="{ inactive: currentIndex == 0 }"
            @click="moveToPrevious()"
            aria-label="Previous Slide"
            :tabindex="currentIndex == 0 ? '-1' : 0"
          >
            <svg
              viewBox="0 0 22 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              aria-hidden="true"
              focusable="false"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-9.000000, 0.000000)">
                  <g
                    transform="translate(20.000000, 20.000000) scale(-1, 1) translate(-20.000000, -20.000000) translate(9.000000, 0.000000)"
                  >
                    <path
                      d="M3.22666667,1.34736842 C2.60750337,0.767665557 1.6426463,0.784770788 1.04422099,1.38605937 C0.445795689,1.98734795 0.428771911,2.95682157 1.00571429,3.57894737 L17.767619,20.4210526 L1.00571429,36.6736842 C0.428771911,37.29581 0.445795689,38.2652836 1.04422099,38.8665722 C1.6426463,39.4678608 2.60750337,39.484966 3.22666667,38.9052632 L21.9161905,20.4210526 L3.22666667,1.34736842 Z"
                      fill="#ebf347"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </div>
        <div class="timeline-carousel__cards">
          <div
            v-for="(card, index) in getCardData"
            :key="index"
            class="timeline-carousel__card-wrapper"
            :class="{ active: index == currentIndex }"
            v-show="showCards(index)"
          >
            <button
              class="timeline-carousel__card-top"
              :class="{ active: index == currentIndex }"
              @click="updateIndex(index)"
              aria-haspopup="true"
              :aria-expanded="(index == currentIndex).toString()"
            >
              <span class="timeline-carousel__card-top-year">
                {{ card.year }}
              </span>
              <span class="timeline-carousel__card-top-carat">
                <svg
                  viewBox="0 0 40 22"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  role="img"
                  aria-hidden="true"
                  focusable="false"
                >
                  <g
                    id="Styles"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g transform="translate(-293.000000, -208.000000)">
                      <rect
                        id="Rectangle"
                        stroke="#ebf347"
                        x="62"
                        y="121"
                        width="1448"
                        height="313"
                      ></rect>
                      <g
                        id="Arrow_simple_rightt"
                        transform="translate(293.000000, 199.000000)"
                      >
                        <g
                          transform="translate(20.000000, 20.000000) rotate(-270.000000) translate(-20.000000, -20.000000) translate(9.000000, -0.000000)"
                        >
                          <path
                            d="M3.22666667,1.34736842 C2.60750337,0.767665557 1.6426463,0.784770788 1.04422099,1.38605937 C0.445795689,1.98734795 0.428771911,2.95682157 1.00571429,3.57894737 L17.767619,20.4210526 L1.00571429,36.6736842 C0.428771911,37.29581 0.445795689,38.2652836 1.04422099,38.8665722 C1.6426463,39.4678608 2.60750337,39.484966 3.22666667,38.9052632 L21.9161905,20.4210526 L3.22666667,1.34736842 Z"
                            fill="#ebf347"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
            </button>

            <transition name="carousel-slide">
              <div
                class="timeline-carousel__card-content"
                v-if="index == currentIndex"
              >
                <div class="base-lockup--dark">
                  <h3 class="base-lockup__heading base-lockup__heading--3">
                    {{ card.title }}
                  </h3>
                  <p class="base-lockup__copy">
                    {{ card.text }}
                  </p>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="timeline-carousel__controls timeline-carousel__prev">
          <button
            :class="{ inactive: currentIndex == getCardLength - 1 }"
            @click="moveToNext()"
            aria-label="Next slide"
            :tabindex="currentIndex == getCardLength - 1 ? '-1' : 0"
          >
            <svg
              viewBox="0 0 22 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              aria-hidden="true"
              focusable="false"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-461.000000, -199.000000)">
                  <rect
                    stroke="#ebf347"
                    x="62"
                    y="121"
                    width="1448"
                    height="313"
                  ></rect>
                  <g transform="translate(452.000000, 199.000000)">
                    <g transform="translate(9.000000, 0.000000)">
                      <path
                        d="M3.22666667,1.34736842 C2.60750337,0.767665557 1.6426463,0.784770788 1.04422099,1.38605937 C0.445795689,1.98734795 0.428771911,2.95682157 1.00571429,3.57894737 L17.767619,20.4210526 L1.00571429,36.6736842 C0.428771911,37.29581 0.445795689,38.2652836 1.04422099,38.8665722 C1.6426463,39.4678608 2.60750337,39.484966 3.22666667,38.9052632 L21.9161905,20.4210526 L3.22666667,1.34736842 Z"
                        fill="#ebf347"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div id="end-timeline-carousel" />
  </section>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: '',
    },
    cards: {
      type: String,
    },
  },
  data() {
    return {
      currentIndex: 0,
    }
  },
  computed: {
    getCardData: function() {
      // Parses the JSON and orders so that the most recent shows up first
      return JSON.parse(this.cards)
        .slice()
        .sort(function(a, b) {
          return b.year - a.year
        })
    },
    getCardLength: function() {
      return JSON.parse(this.cards).length
    },
  },
  methods: {
    updateIndex: function(newIndex) {
      this.currentIndex = newIndex
    },

    moveToNext: function() {
      if (++this.currentIndex >= this.getCardLength)
        this.currentIndex = this.getCardLength - 1
    },
    moveToPrevious: function() {
      if (--this.currentIndex == -1) this.currentIndex = 0
    },
    showCards: function(index) {
      let cards = JSON.parse(this.cards)
      if (cards.length <= 5) {
        return true
      } else if (this.currentIndex <= 1 && index < 5) {
        return true
      } else if (
        index >= cards.length - 5 &&
        this.currentIndex > cards.length - 5
      ) {
        return true
      } else if (
        this.currentIndex < cards.length - 4 &&
        index >= this.currentIndex - 2 &&
        index <= this.currentIndex + 2
      ) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-in;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.carousel-slide-enter-active,
.carousel-slide-leave-active {
  max-height: 350px;
  transition: all 0.5s;

  > * {
    transition: opacity 0.75s cubic-bezier(0.78, 0.02, 0.46, -0.14);
  }

  @media (min-width: 1024px) {
    max-height: 28rem;
    max-width: 25rem;
  }
}
.carousel-slide-leave-active {
  > * {
    transition: opacity 0.15s;
  }
}

.carousel-slide-enter,
.carousel-slide-leave-to {
  max-height: 0;
  overflow: hidden;

  > * {
    opacity: 0;
    clip-path: inset(0 99% 99% 0);
  }

  @media (min-width: 1024px) {
    max-height: 20rem;
    margin-bottom: 8rem;
    max-width: 0;
  }
}
</style>
